// PROFILE COMMONS
export const PROFILE_HOME = 'PROFILE_HOME';

// PROFILE ADMINISTRATION
export const PROFILE_READ_USER = 'PROFILE_READ_USER';
export const PROFILE_WRITER_USER = 'PROFILE_WRITER_USER';
export const PROFILE_READ_PROFILE = 'PROFILE_READ_PROFILE';
export const PROFILE_WRITER_PROFILE = 'PROFILE_WRITER_PROFILE';
export const PROFILE_WRITE_FEATURE_FLAGS = 'PROFILE_WRITE_FEATURE_FLAGS';

// PROFILE REPORT
export const PROFILE_READ_REPORT = 'PROFILE_READ_REPORT';
export const PROFILE_WRITER_REPORT = 'PROFILE_WRITER_REPORT';

// PROFILE REPORT MASTER
export const PROFILE_READ_AUTHOR = 'PROFILE_READ_AUTHOR';
export const PROFILE_WRITER_AUTHOR = 'PROFILE_WRITER_AUTHOR';
export const PROFILE_READ_REPORT_TYPE = 'PROFILE_READ_REPORT_TYPE';
export const PROFILE_WRITER_REPORT_TYPE = 'PROFILE_WRITER_REPORT_TYPE';
export const PROFILE_READ_SPECIALTY = 'PROFILE_READ_SPECIALTY';
export const PROFILE_WRITER_SPECIALTY = 'PROFILE_WRITER_SPECIALTY';

// PROFILE DRUG
export const PROFILE_READ_DRUG = 'PROFILE_READ_DRUG';
export const PROFILE_WRITER_DRUG = 'PROFILE_WRITER_DRUG';

// PROFILE DRUG GENERIC
export const PROFILE_READ_DRUG_GENERIC = 'PROFILE_READ_DRUG_GENERIC';
export const PROFILE_WRITER_DRUG_GENERIC = 'PROFILE_WRITER_DRUG_GENERIC';

// PROFILE DRUG TREATMENT
export const PROFILE_READ_DRUG_TREATMENT = 'PROFILE_READ_DRUG_TREATMENT';
export const PROFILE_WRITER_DRUG_TREATMENT = 'PROFILE_WRITER_DRUG_TREATMENT';

// PROFILE DRUG CALCULATOR
export const PROFILE_READ_DRUG_CALCULATOR = 'PROFILE_READ_DRUG_CALCULATOR';

// PROFILE DRUG MASTER
export const PROFILE_READ_ADMINISTRATION = 'PROFILE_READ_ADMINISTRATION';
export const PROFILE_WRITER_ADMINISTRATION = 'PROFILE_WRITER_ADMINISTRATION';
export const PROFILE_READ_ADVERSE_EFFECT = 'PROFILE_READ_ADVERSE_EFFECT';
export const PROFILE_WRITER_ADVERSE_EFFECT = 'PROFILE_WRITER_ADVERSE_EFFECT';
export const PROFILE_READ_COMMERCIAL = 'PROFILE_READ_COMMERCIAL';
export const PROFILE_WRITER_COMMERCIAL = 'PROFILE_WRITER_COMMERCIAL';
export const PROFILE_READ_COMMERCIAL_FORM = 'PROFILE_READ_COMMERCIAL_FORM';
export const PROFILE_WRITER_COMMERCIAL_FORM = 'PROFILE_WRITER_COMMERCIAL_FORM';
export const PROFILE_READ_CONTRAINDICATION = 'PROFILE_READ_CONTRAINDICATION';
export const PROFILE_WRITER_CONTRAINDICATION = 'PROFILE_WRITER_CONTRAINDICATION';
export const PROFILE_READ_DRUG_SUBTYPE = 'PROFILE_READ_DRUG_SUBTYPE';
export const PROFILE_WRITER_DRUG_SUBTYPE = 'PROFILE_WRITER_DRUG_SUBTYPE';
export const PROFILE_READ_DRUG_TYPE = 'PROFILE_READ_DRUG_TYPE';
export const PROFILE_WRITER_DRUG_TYPE = 'PROFILE_WRITER_DRUG_TYPE';
export const PROFILE_READ_FORMULA = 'PROFILE_READ_FORMULA';
export const PROFILE_WRITER_FORMULA = 'PROFILE_WRITER_FORMULA';
export const PROFILE_READ_FREQUENCY_QUANTITY = 'PROFILE_READ_FREQUENCY_QUANTITY';
export const PROFILE_WRITER_FREQUENCY_QUANTITY = 'PROFILE_WRITER_FREQUENCY_QUANTITY';
export const PROFILE_READ_FREQUENCY_TIME = 'PROFILE_READ_FREQUENCY_TIME';
export const PROFILE_WRITER_FREQUENCY_TIME = 'PROFILE_WRITER_FREQUENCY_TIME';
export const PROFILE_READ_MODIFIER = 'PROFILE_READ_MODIFIER';
export const PROFILE_WRITER_MODIFIER = 'PROFILE_WRITER_MODIFIER'
export const PROFILE_READ_LABORATORY = 'PROFILE_READ_LABORATORY';
export const PROFILE_WRITER_LABORATORY = 'PROFILE_WRITER_LABORATORY'
export const PROFILE_READ_PATHOLOGY = 'PROFILE_READ_PATHOLOGY';
export const PROFILE_WRITER_PATHOLOGY = 'PROFILE_WRITER_PATHOLOGY';
export const PROFILE_READ_PHARMACEUTICAL_FORM = 'PROFILE_READ_PHARMACEUTICAL_FORM';
export const PROFILE_WRITER_PHARMACEUTICAL_FORM = 'PROFILE_WRITER_PHARMACEUTICAL_FORM';
export const PROFILE_READ_SEVERITY = 'PROFILE_READ_SEVERITY';
export const PROFILE_WRITER_SEVERITY = 'PROFILE_WRITER_SEVERITY';
export const PROFILE_READ_SITUATION = 'PROFILE_READ_SITUATION';
export const PROFILE_WRITER_SITUATION = 'PROFILE_WRITER_SITUATION';
export const PROFILE_READ_UNIT_MEASURE = 'PROFILE_READ_UNIT_MEASURE';
export const PROFILE_WRITER_UNIT_MEASURE = 'PROFILE_WRITER_UNIT_MEASURE';

// PROFILE CONGRESS
export const PROFILE_READ_CONGRESS = 'PROFILE_READ_CONGRESS';
export const PROFILE_WRITER_CONGRESS = 'PROFILE_WRITER_CONGRESS';

// PROFILE CONGRESS SPONSOR
export const PROFILE_READ_CONGRESS_SPONSOR = 'PROFILE_READ_CONGRESS_SPONSOR';
export const PROFILE_WRITER_CONGRESS_SPONSOR = 'PROFILE_WRITER_CONGRESS_SPONSOR'

// PROFILE CONGRESS MIGRATE
export const PROFILE_READ_MIGRATE = 'PROFILE_READ_MIGRATE';
export const PROFILE_WRITER_MIGRATE = 'PROFILE_WRITER_MIGRATE'

// PROFILE CONGRESS MASTER SPONSOR
export const PROFILE_READ_SPONSOR = 'PROFILE_READ_SPONSOR';
export const PROFILE_WRITER_SPONSOR = 'PROFILE_WRITER_SPONSOR'

// PROFILE CONGRESS MASTER SPONSOR TYPE
export const PROFILE_READ_SPONSOR_TYPE = 'PROFILE_READ_SPONSOR_TYPE';
export const PROFILE_WRITER_SPONSOR_TYPE = 'PROFILE_WRITER_SPONSOR_TYPE'


export const PROFILE_VIEW_ADMINISTRATION = [
  PROFILE_READ_USER,
  PROFILE_READ_PROFILE,
  PROFILE_WRITE_FEATURE_FLAGS
];

export const PROFILE_VIEW_REPORT = [
  PROFILE_READ_REPORT
];

export const PROFILE_VIEW_REPORT_COMPONENT = [
  PROFILE_READ_AUTHOR,
  PROFILE_READ_REPORT_TYPE,
  PROFILE_READ_SPECIALTY
];

export const PROFILE_VIEW_DRUG = [
  PROFILE_READ_DRUG,
  PROFILE_READ_DRUG_TREATMENT,
  PROFILE_READ_DRUG_CALCULATOR,
  PROFILE_READ_DRUG_GENERIC
];

export const PROFILE_VIEW_DRUG_COMPONENT = [
  PROFILE_READ_ADMINISTRATION,
  PROFILE_READ_ADVERSE_EFFECT,
  PROFILE_READ_COMMERCIAL,
  PROFILE_READ_COMMERCIAL_FORM,
  PROFILE_READ_CONTRAINDICATION,
  PROFILE_READ_DRUG_SUBTYPE,
  PROFILE_READ_DRUG_TYPE,
  PROFILE_READ_FORMULA,
  PROFILE_READ_FREQUENCY_QUANTITY,
  PROFILE_READ_FREQUENCY_TIME,
  PROFILE_READ_MODIFIER,
  PROFILE_READ_LABORATORY,
  PROFILE_READ_PATHOLOGY,
  PROFILE_READ_PHARMACEUTICAL_FORM,
  PROFILE_READ_SEVERITY,
  PROFILE_READ_SITUATION,
  PROFILE_READ_UNIT_MEASURE
];

export const PROFILE_VIEW_CONGRESS = [
  PROFILE_READ_CONGRESS,
  PROFILE_READ_CONGRESS_SPONSOR,
  PROFILE_READ_MIGRATE
];

export const PROFILE_VIEW_CONGRESS_COMPONENT = [
  PROFILE_READ_SPONSOR,
  PROFILE_READ_REPORT_TYPE,
];

// PROFILE VACCINE
export const PROFILE_READ_VACCINE = 'PROFILE_READ_VACCINE';
export const PROFILE_WRITER_VACCINE = 'PROFILE_WRITER_VACCINE';

// PROFILE VACCINE CORE
export const PROFILE_READ_VACCINE_CORE = 'PROFILE_READ_VACCINE_CORE';
export const PROFILE_WRITER_VACCINE_CORE = 'PROFILE_WRITER_VACCINE_CORE';

// PROFILE VACCINE DOSES
export const PROFILE_READ_VACCINE_DOSES = 'PROFILE_READ_VACCINE_DOSES';
export const PROFILE_WRITER_VACCINE_DOSES = 'PROFILE_WRITER_VACCINE_DOSES';

// PROFILE VACCINE ALERTS
export const PROFILE_READ_VACCINE_ALERTS = 'PROFILE_READ_VACCINE_ALERTS';
export const PROFILE_WRITER_VACCINE_ALERTS = 'PROFILE_WRITER_VACCINE_ALERTS';

// PROFILE VACCINE RULES
export const PROFILE_READ_VACCINE_RULES = 'PROFILE_READ_VACCINE_RULES';
export const PROFILE_WRITER_VACCINE_RULES = 'PROFILE_WRITER_VACCINE_RULES';

// PROFILE VACCINE QUESTIONS
export const PROFILE_READ_VACCINE_QUESTIONS = 'PROFILE_READ_VACCINE_QUESTIONS';
export const PROFILE_WRITER_VACCINE_QUESTIONS = 'PROFILE_WRITER_VACCINE_QUESTIONS';

export const PROFILE_VIEW_VACCINE = [
  PROFILE_READ_VACCINE,
  PROFILE_READ_VACCINE_CORE,
  PROFILE_READ_VACCINE_DOSES,
  PROFILE_READ_VACCINE_ALERTS,
  PROFILE_READ_VACCINE_RULES,
  PROFILE_READ_VACCINE_QUESTIONS
];

export const PROFILE_VIEW_VACCINE_COMPONENT = [
  PROFILE_READ_VACCINE_CORE,
  PROFILE_READ_VACCINE_DOSES,
  PROFILE_READ_VACCINE_ALERTS,
  PROFILE_READ_VACCINE_RULES,
  PROFILE_READ_VACCINE_QUESTIONS
];
